import React from "react";
import "./footer.scss"

const Footer = React.memo(() => {
  console.log('🔄 Footer component rendering');
  return (
    <div className="footer">
      <span></span>
      <span> &copy; 9AR Store All Rights Reserved {new Date().getFullYear()} </span>
    </div>
  );
});

Footer.displayName = 'Footer';
export default Footer;